<div class="row">
    <div class="col-sm-12">
      <h3 class="sub-title alert alert-info">User Activities</h3></div>
    
  </div>
<div class="table-responsive" *ngIf="userActivityList.length>0">
<table  datatable [dtOptions]="dtOptions" class="table table-striped display compact">
    <thead>
    <tr>
    <th>User</th>
    <th>Date</th>
    <th>Name</th>
    <th>Device</th>
    <th>Browser</th>
    <th>Ip</th>
    </tr>
    </thead>
    
    <tbody>
    
    <tr *ngFor="let userActivity of userActivityList;">
        <td>{{userActivity.email}}</td>
        <td>{{userActivity.datecreated}}</td>
        <td>{{userActivity.name}}</td>
        <td>{{userActivity.deviceName}}</td>
        <td>{{userActivity.browserName}}</td>
        <td>{{userActivity.ipAddress}}</td>
    </tr>
    
    </tbody>
     
</table>
</div>
<app-spinner *ngIf="(userActivityList.length==0) && loading"></app-spinner>
<div *ngIf="(userActivityList.length==0) && !loading" class="text-center">No Records Found </div>
